import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { adminActions } from '../../../../../state/modules/admin';
import { LoadingButton } from '../../../../components';

const RunPendingKaplanImport = ({ run, loading }) => {
  return <div id='run-pending-kaplan-import-task'>
    <LoadingButton loading={loading} text={'Run'} onClick={run} />
  </div>
}

const mapStateToProps = ({ admin }) => ({
  isUploading: admin.isUploadingCPD,
  uploadResult: admin.externalCpdUploadResult,
})
const mapDispatchToProps = (dispatch) => ({
  upload: bindActionCreators(adminActions.admin.uploadExternalCpd, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    {
      loading: false
    },
    {
      setLoading: () => (loading) => ({ loading })
    }
  ),
  withHandlers({
    run: ({ data, setLoading, upload }) => () => {
      const parsed = JSON.parse(data)
      setLoading(true)
      upload(parsed)
    }
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        isUploading,
        setLoading
      } = this.props

      if (prevProps.isUploading && !isUploading) {
        setLoading(false)
      }
    }
  })
)(RunPendingKaplanImport)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/admin-task-portal/partials/run-pending-kaplan-import.js